import * as THREE from 'three';

/** Top-down ortho rig. Sits above the arena looking straight down; only shakes on impact. */
export class CameraRig {
  private readonly base: THREE.Vector3;
  private readonly target: THREE.Vector3;

  constructor(private readonly camera: THREE.OrthographicCamera, fieldCenterZ = 2.7) {
    // Centered on the field center so the play area fits the camera symmetrically
    // and the paddle stays visible at the bottom of the screen.
    this.base = new THREE.Vector3(0, 20, fieldCenterZ);
    this.target = new THREE.Vector3(0, 0, fieldCenterZ);
    // +z is "toward the paddle". We want the paddle at the bottom of the screen,
    // so set camera up so -z projects upward on screen (bricks on top, paddle at bottom).
    this.camera.up.set(0, 0, -1);
    this.snap();
  }

  snap(): void {
    this.camera.position.copy(this.base);
    this.camera.lookAt(this.target);
  }

  update(_delta: number, shake = 0): void {
    this.camera.position.copy(this.base);
    if (shake > 0) {
      this.camera.position.x += (Math.random() - 0.5) * shake;
      this.camera.position.z += (Math.random() - 0.5) * shake * 0.6;
    }
    this.camera.lookAt(this.target);
  }
}
